<div class="tt-import-guideline-dialog_description">
  {{ 'ImportGuidelineDialog.Description' | transloco }}
</div>

<tt-form-field class="tt-import-guideline-dialog_target-organisation">
  <label for="import-guideline-dialog_target-organisation" ttLabel>
    {{ 'ImportGuidelineDialog.TargetOrganisation.Label' | transloco }}
  </label>
  <tt-select
    data-testid="import-guideline-dialog_target-organisation-select"
    id="import-guideline-dialog_target-organisation"
    [ngModel]="selectedTargetOrganisationId()"
    [placeholder]="'ImportGuidelineDialog.TargetOrganisation.Placeholder' | transloco"
    [readonly]="targetOrganisations.length === 1"
    (ngModelChange)="selectedTargetOrganisationId.set($event)">
    <tt-select-items>
      @for (organisation of targetOrganisations; track organisation.id) {
        <tt-option [attr.data-testid]="'import-guideline-dialog_target-organisation-option-' + organisation.id" [value]="organisation.id">
          {{ organisation.displayName }}
        </tt-option>
      }
    </tt-select-items>
  </tt-select>
</tt-form-field>

<tt-shared-guideline-import-update-settings
  (forwardEmailNotificationsChange)="forwardEmailNotifications.set($event)"
  (updateModeChange)="updateMode.set($event)" />

<div class="tt-import-guideline-dialog_actions">
  <button data-testid="import-guideline-dialog_cancel-button" ttButton [variant]="'secondary'" (click)="dialogRef.close()">
    <span>{{ 'Cancel' | transloco }}</span>
  </button>
  <span class="tt-import-guideline-dialog_actions-spacer"></span>
  <button
    data-testid="import-guideline-dialog_import-button"
    ttButton
    type="raised"
    [disabled]="!isImportGuidelineDataValid()"
    (click)="handleImportClicked()">
    <span>
      {{
        updateMode() === 'automatic' ? ('ImportGuidelineDialog.ImportAndPublish' | transloco) : ('ImportGuidelineDialog.Import' | transloco)
      }}
    </span>
  </button>
</div>
